import React from 'react'

import { isCms, isLocal } from '../../utility'

export function Loader({ showBackground = true }) {
  return (
    <div className={showBackground ? 'u-bgColorOffwhite' : ''}>
      <div className="u-padding6gu u-marginBottom4gu">
        <div className="u-textCenter">
          <img
            src={`${
              isLocal() || isCms() ? '/site' : ''
            }/webfiles/latest/assets/cti/images/cti-page-loader-icon.gif`}
            alt="Loading"
          />
        </div>
      </div>
    </div>
  )
}
